module.exports = __webpack_public_path__ + "static/media/bg.d80823a5.jpg";